import type { FC } from "react";
import { TEXT } from "@/constants/text";
import styles from "@/pages/admin/UserManagementPage/UserFilters.module.css";

interface UserFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  resultCount: number;
}

const UserFilters: FC<UserFiltersProps> = ({
  search,
  onSearchChange,
  resultCount,
}) => (
  <div className={styles.filters}>
    <div className={styles.searchWrapper}>
      <i aria-hidden="true" className={`pi pi-search ${styles.searchIcon}`} />
      <input
        aria-label={TEXT.userManagement.searchPlaceholder}
        className={styles.searchInput}
        placeholder={TEXT.userManagement.searchPlaceholder}
        type="search"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
      />
    </div>

    <span className={styles.resultCount}>
      {TEXT.userManagement.usersCountLabel.replace("{0}", String(resultCount))}
    </span>
  </div>
);

export default UserFilters;
